<template>
  <div class="menu-tile" @click.stop="$emit('click')">
    <div class="icon-circle">
      <img :src="require(`@/assets/icons/navigation-menu/${icon}.svg`)" alt=""/>
    </div>
    <div class="text ri-small-body">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'MenuTile',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

$tile-size: 50px;

.menu-tile {
  display: flex;
  width: $tile-size;
  flex-direction: column;
  align-items: center;
  row-gap: 13px;
  cursor: pointer;

  .text {
    width: 56px;
    text-align: center;
    color: $riseup_black;
    line-height: 14px;
  }

  .icon-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $riseup_white;
    border-radius: 50%;
    width: 100%;
    height: $tile-size;
  }
}
</style>
